const OBJECT_ID_REF_FIELDS = ['venue_id', 'chat_pop_up_id']
const UNIVERSAL_TEMPLATE_ONLY_FIELDS = [
  'modules',
  'subtype',
  'expires_at',
  'is_evergreen',
  'show_in_internal_search',
  'show_in_google_search'
]
/** FAQ-only Page fields. `hero` is shared by tours/VLP/prem hosp — do not strip it here. */
const FAQ_ONLY_FIELDS = ['sections', 'attending', 'venue']
const MONGO_DOC_FIELDS = ['_id', '__v', 'created_at', 'updated_at']

/** FAQ hero: title + image.src (admin may send image.url). */
export function normalizeFaqHero (hero) {
  const title = String(hero?.title ?? '').trim()
  const image = hero?.image
  if (!image || typeof image !== 'object') {
    return { title, image: { src: '', alt: '' } }
  }
  const src = image.src || image.url || ''
  return {
    title,
    image: {
      src,
      alt: image.alt || (src ? String(src).split('/').pop() : '')
    }
  }
}

export function isFaqPage (page) {
  return page?.type === 'faq'
}

export function sanitizePagePayload (page, { vlpHeroPromotedEvents } = {}) {
  const cleaned = { ...page }
  if (vlpHeroPromotedEvents !== undefined) {
    cleaned.vlpHeroPromotedEvents = vlpHeroPromotedEvents
  }
  MONGO_DOC_FIELDS.forEach(field => delete cleaned[field])
  OBJECT_ID_REF_FIELDS.forEach(field => {
    if (cleaned[field] === '' || cleaned[field] === null || cleaned[field] === undefined) {
      delete cleaned[field]
    }
  })
  if (cleaned.type !== 'universal-template') {
    UNIVERSAL_TEMPLATE_ONLY_FIELDS.forEach(field => delete cleaned[field])
  }
  if (cleaned.type !== 'faq') {
    FAQ_ONLY_FIELDS.forEach(field => delete cleaned[field])
  }
  return cleaned
}

/** Explicit FAQ API body — always includes type and sections. */
export function buildFaqPageUpdatePayload (page) {
  return sanitizePagePayload({
    type: 'faq',
    name: page?.name,
    slug: page?.slug,
    page_meta: page?.page_meta,
    form: page?.form,
    sections: page?.sections ?? [],
    attending: page?.attending,
    venue: page?.venue,
    hero: normalizeFaqHero(page?.hero),
    show_chatbot: page?.show_chatbot,
    show_optin_form: page?.show_optin_form,
    chat_pop_up_id: page?.chat_pop_up_id,
    venue_id: page?.venue_id
  })
}
